export default "__VITE_ASSET__BGNLdZLQ__"